import { useCallback } from "react";
import type { Dice, Holds } from "@yamber/rules-engine";
import { Die } from "./Die";

interface DiceRowProps {
  dice: Dice;
  holds: Holds;
  rollCount: number;
  onToggleHold: (index: number) => void;
}

export function DiceRow({ dice, holds, rollCount, onToggleHold }: DiceRowProps) {
  const canHold = rollCount > 0 && rollCount < 3;

  // Keyboard navigation within dice row
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent, index: number) => {
      const diceCount = dice.length;
      let nextIndex = -1;

      switch (e.key) {
        case "ArrowLeft":
          nextIndex = index > 0 ? index - 1 : diceCount - 1;
          break;
        case "ArrowRight":
          nextIndex = index < diceCount - 1 ? index + 1 : 0;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = diceCount - 1;
          break;
      }

      if (nextIndex >= 0) {
        e.preventDefault();
        const diceButtons = document.querySelectorAll(".die");
        (diceButtons[nextIndex] as HTMLElement)?.focus();
      }
    },
    [dice.length]
  );

  const heldCount = holds.filter(Boolean).length;

  return (
    <div
      className="dice-row"
      role="group"
      aria-label={`Dice - ${heldCount} of ${dice.length} held`}
    >
      {dice.map((value, index) => (
        <Die
          key={index}
          value={value}
          held={holds[index] ?? false}
          disabled={!canHold}
          onToggleHold={() => onToggleHold(index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  );
}
